<template>
  <div @click="!disable && (showEffectiveTypeDialog = !showEffectiveTypeDialog)">
    <q-select
      :model-value="$_.startCase(internalValue)"
      label="Effective Type"
      bottom-slots
      map-options
      emit-value
      :disable="disable"
    >
      <q-tooltip>
        <effective-type-detail
          style="max-width: 600px;"
          :effective-type="internalValue"
          :show-void-control="false"
        />
      </q-tooltip>
    </q-select>
    <effective-type-dialog
      v-model="showEffectiveTypeDialog"
      :effective-type="internalValue"
      @select="internalValue = $event"
    />
  </div>
</template>

<script>

import EffectiveTypeDetail from 'src/modules/admin/effective-type/EffectiveTypeDetail'
import EffectiveTypeDialog from 'src/modules/admin/effective-type/EffectiveTypeDialog'

export default {
  name: 'EffectiveTypeSelect',
  components: {
    EffectiveTypeDialog,
    EffectiveTypeDetail
  },
  props: {
    modelValue: {
      type: String,
      required: false,
      default: null
    },
    disable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      internalValue: this.modelValue,
      showEffectiveTypeDialog: false
    }
  },
  watch: {
    internalValue () {
      this.$emit('update:model-value', this.internalValue)
    },
    showEffectiveTypeDialog () {
      console.log('showEffectiveTypeDialog', this.showEffectiveTypeDialog)
    }
  }
}

</script>

<style lang="scss" scoped>
.effective-timeline-table {
  td {
    width: 100px;
    text-align: center;
  }
}
</style>
